<template>
  <a-modal
    v-model="dialogVisible"
    title="选择已有品目"
    width="1186px"
    :mask-closable="false"
    @cancel="onCancel"
    @ok="onOk"
  >
    <div class="dialog-body">
      <!-- 左侧分类树 -->
      <div class="body-left">
        <a-input-search
          class="m-b-24"
          placeholder="请输入分类名称"
          enter-button
          @search="onClassifySearch"
        />
        <el-scrollbar>
          <el-tree
            ref="tree"
            class="tree"
            :data="classifyTree"
            :props="defaultProps"
            :filter-node-method="filterNode"
            node-key="categoryId"
            :default-expanded-keys="[0]"
            highlight-current
            @node-click="selectClassify"
          >
            <span slot-scope="{ node, data }" class="custom-tree-node">
              <span
                class="node-label text-ellipsis"
                :title="node.label"
                :class="{
                  active: currentClassify.categoryId === data.categoryId
                }"
              >
                {{ node.label || '-' }}
              </span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <!-- 右侧对应分类的品目列表 -->
      <div class="body-right p-24">
        <jczh-table-content
          :data="table"
          :option="tableOption"
          pagination
          :page.sync="page"
          :limit.sync="size"
          :total="total"
          :show-index="false"
          @row-click="onMaterialChange"
          @pagination="getList"
        >
          <template v-slot:radio="{ row }">
            <el-radio :value="currentMaterial.itemId" :label="row.itemId" />
          </template>
        </jczh-table-content>
      </div>
    </div>
  </a-modal>
</template>

<script>
// 接口
import {
  getMaterialClassifyTreeApi,
  getMaterialPageByClassifyApi
} from '@/api/material/management'
// 工具
import Dict from '@/utils/dict-utils'

// 查询类型
const queryTypeDict = new Dict({
  UNCLASSIFIED: { label: '未分组', value: 0 },
  ALL: { label: '所有分组', value: 1 },
  SPECIFIED: { label: '指定分组', value: 2 }
})

/**
 * @description 选择已有品目弹窗
 */
export default {
  name: 'SelectMaterial',

  model: {
    prop: 'visible',
    event: 'change'
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 分类树
      classifyTree: [],
      defaultProps: {
        children: 'children',
        label: 'categoryName'
      },
      // 当前选择的分类
      currentClassify: {},

      filterForm: {
        // 关键词
        nameOrCode: '',
        // 分类id
        categoryId: '',
        // 查询类型
        queryType: queryTypeDict.ALL.value
      },
      // 当前分类下的品目列表（无分类则是所有品目列表）
      table: [],
      tableOption: [
        {
          label: '',
          prop: 'checked',
          slotName: 'radio',
          width: '40px',
          columnAttrs: { align: 'left' }
        },
        {
          label: '品目名称',
          prop: 'itemName',
          columnAttrs: { align: 'left' }
        },
        { label: '编码', prop: 'itemCode', columnAttrs: { align: 'left' } },
        {
          label: '分类',
          prop: 'categoryNameTree',
          columnAttrs: { align: 'left' },
          filter: value => value.join('>')
        },
        { label: '单位', prop: 'itemUnit', columnAttrs: { align: 'left' } }
      ],
      total: 0,
      page: 1,
      size: 10,
      // 当前选择的品目
      currentMaterial: {}
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.getClassifyTree()
        this.getList()
        this.currentMaterial = {}
      }
    }
  },

  methods: {
    /**
     * 关闭弹窗
     */
    onCancel() {
      this.dialogVisible = false
    },

    /**
     * 点击确定
     */
    onOk() {
      this.$emit('confirm', this.currentMaterial)
      this.dialogVisible = false
    },

    /**
     * 获取品目分类树
     */
    getClassifyTree() {
      getMaterialClassifyTreeApi()
        .then(res => {
          const _data = res.data || {}
          // 基础分类树
          const categoryTree = _data.categoryTree || []
          // 添加全部分类祖先节点和特殊的无分类一级节点
          categoryTree.push({
            categoryId: -1,
            categoryName: '无分类品目',
            default: true,
            itemCnt: _data.notCategoryCnt || 0,
            queryType: queryTypeDict.UNCLASSIFIED.value
          })
          this.classifyTree = [
            {
              categoryId: 0,
              categoryName: '全部分类',
              itemCnt: _data.itemCnt,
              default: true,
              children: categoryTree,
              queryType: queryTypeDict.ALL.value
            }
          ]
        })
        .catch(err => {
          console.error('获取品目分类树失败', err)
          if (err.message) this.$message.error(err.message)
        })
    },

    /**
     * 选择分类
     */
    selectClassify(data) {
      this.currentClassify = data
      this.filterForm.categoryId = data.categoryId
      // 如果categoryId有值，则是指定分类搜索
      this.filterForm.queryType =
        data.categoryId > 0 ? queryTypeDict.SPECIFIED.value : data.queryType
      this.getList()
    },

    filterNode(value, data) {
      console.log('value, data', value, data)
      if (!value) return true
      return data?.categoryName?.indexOf(value) !== -1
    },

    /**
     * 搜索分类
     * @param value
     */
    onClassifySearch(value) {
      this.$refs.tree.filter(value)
    },

    /**
     * 获取品目分页列表
     */
    getList() {
      const params = { page: this.page, size: this.size, ...this.filterForm }
      getMaterialPageByClassifyApi(params)
        .then(res => {
          this.table = res.data.records || []
          this.total = res.data.total || 0
        })
        .catch(err => {
          console.error('获取品目分页列表失败', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 切换当前选择的品目
     */
    onMaterialChange(val) {
      this.currentMaterial = val
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-modal-body {
  padding: 0;
}

.dialog-body {
  min-height: 600px;
  display: flex;

  .body-left {
    width: 296px;
    padding: 24px;
    border-right: 1px solid $info-fourth-color;

    .tree {
      ::v-deep .el-tree-node__content {
        &:hover {
          background-color: $primary-background-color;
          color: $primary-color;
        }
      }
    }
  }

  .body-right {
    flex: 1;
  }
}

::v-deep .el-radio__label {
  display: none;
}
</style>
